import { useApolloClient } from '@apollo/client/react';

import { TasksDocument } from 'src/graphql/actions/tasks/tasks.query';

export const useRefetchTasks = () => {
  const client = useApolloClient();

  return () => {
    client.cache.evict({ fieldName: 'tasks' });
    client.cache.gc();
    client.refetchQueries({ include: [TasksDocument] });
  };
};
